import React from 'react'
import strukturaOrganizative from "../assets/strukturaOrganizative.png"

const StrukturaOrganizativeNdermarrjes = () => {
  return (
    <div className='w-full px-1 lg:px-[50px] py-3'>
        <img src={strukturaOrganizative} alt='' className='w-full object-cover mt-10 lg:mt-5' />
    </div>
  )
}

export default StrukturaOrganizativeNdermarrjes